/* NWIRA — FAQ Accordion + Sticky ATC
   Le Pack Selector est géré inline dans sections/nwira-pack-selector.liquid */
(function () {
  'use strict';

  /* ── FAQ Accordion ── */
  function initFAQ() {
    var items = document.querySelectorAll('.nwira-faq__item');
    items.forEach(function (item) {
      var q = item.querySelector('.nwira-faq__q');
      if (!q) return;
      q.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');
        items.forEach(function (i) { i.classList.remove('open'); });
        if (!isOpen) item.classList.add('open');
      });
    });
  }

  /* ── Sticky ATC ── */
  function initStickyATC() {
    var bar = document.getElementById('nwira-sticky-atc');
    if (!bar) return;
    var anchor = document.getElementById('nwira-atc-btn') ||
                 document.querySelector('.nwira-pack__cta') ||
                 document.querySelector('.product-form__submit');
    if (!anchor) return;

    var observer = new window.IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          bar.classList.add('visible');
          bar.setAttribute('aria-hidden', 'false');
        } else {
          bar.classList.remove('visible');
          bar.setAttribute('aria-hidden', 'true');
        }
      });
    }, { threshold: 0.1 });
    observer.observe(anchor);

    var stickyBtn = bar.querySelector('.nwira-sticky-atc__btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var mainBtn = document.getElementById('nwira-atc-btn');
        if (mainBtn) { mainBtn.click(); return; }
        var fallback = document.querySelector('[name="add"]') ||
                       document.querySelector('.product-form__submit');
        if (fallback) fallback.click();
      });
    }
  }

  function init() {
    initFAQ();
    initStickyATC();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
